
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { setupSessionTimeout } from "@/utils/sessionManager";
import { useAdminDashboard } from "@/hooks/useAdminDashboard";
import { DashboardHeader } from "@/components/admin/dashboard/DashboardHeader";
import { DashboardContent } from "@/components/admin/dashboard/DashboardContent";
import { requireAuth } from "@/utils/authUtils";

const AdminDashboard = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { 
    profile, 
    profileLoading, 
    surveyResponses, 
    handleSignOut,
    isSuperAdmin,
    currentUserId,
    linkedAccounts
  } = useAdminDashboard();

  // Check authentication on mount
  useEffect(() => {
    requireAuth(navigate);
  }, [navigate]);

  // Set up session timeout
  useEffect(() => {
    const cleanup = setupSessionTimeout(async () => {
      await handleSignOut();
      toast({
        title: "Session Timeout",
        description: "You have been logged out due to inactivity.",
        variant: "destructive",
      });
    });

    return cleanup;
  }, [handleSignOut, toast]);

  if (profileLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-background">
      <div className="w-full max-w-2xl space-y-8 animate-fadeIn">
        <DashboardHeader 
          onSignOut={handleSignOut}
          isSuperAdmin={isSuperAdmin}
        />
        <DashboardContent 
          profile={profile}
          surveyResponses={surveyResponses}
          currentUserId={currentUserId || ''}
          linkedAccounts={linkedAccounts}
        />
      </div>
    </div>
  );
};

export default AdminDashboard;
